import { Tooltip } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles, withStyles } from '@mui/styles';
import { color } from '@kistech/kis-ui';

export const useStyles = (props?: { showDrawer: boolean }) =>
  makeStyles((theme: Theme) =>
    createStyles({
      configSelectorPills: {
        display: 'flex',
        maxWidth: '100%',
        overflowX: 'auto',
        padding: '10px',
        flex: '0 0 auto',
        '& > div': {
          margin: '0 5px',
          flex: '0 0 auto'
        },
        '& > * > button': {
          width: 'auto',
          minWidth: '169px',
          padding: '0 20px',
          [theme.breakpoints.only('md')]: {
            flex: '0 0 169px'
          }
        }
      },
      configHeaderText: {
        lineHeight: '1',
        fontSize: '40px',
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 600,
        letterSpacing: 'normal',
        [theme.breakpoints.down('sm')]: {
          fontSize: '36px'
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: '32px'
        },
        [theme.breakpoints.only('md')]: {
          fontSize: '36px'
        }
      },
      configTableOuterBox: {
        width: '100%',
        flex: 'none',
        background: 'transparent',
        padding: '32px',
        [theme.breakpoints.down('sm')]: {
          padding: '5px 16px 16px'
        }
      },
      configTableContainer: {
        height: '645px',
        paddingBottom: '75px',
        [theme.breakpoints.down('sm')]: {
          height: '790px'
        }
      },
      configHeadersProperty: {
        flex: '0 0 250px',
        paddingLeft: '24px',
        lineHeight: '1.13',
        fontSize: '16px',
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 600,
        height: '70px',
        display: 'flex',
        alignItems: 'center'
      },
      configTableHeaders: {
        flex: 1,
        lineHeight: '1.13',
        fontSize: '16px',
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        height: '70px'
      },
      configActionHeader: {
        flex: '0 0 175px',
        lineHeight: '1.13',
        fontSize: '16px',
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        height: '70px',
        justifyContent: 'end',
        paddingRight: '32px'
      },
      configTableRows: {
        width: '100%',
        border: '0',
        display: 'flex',
        padding: '10px 0px',
        alignItems: 'center',
        borderRadius: '8px',
        backgroundColor: '#fff',
        height: '70px'
      },
      configPropertyCell: {
        flex: '0 0 250px',
        paddingLeft: '24px',
        height: '70px',
        display: 'flex',
        alignItems: 'center'
      },
      configTableValueCell: {
        flex: '1',
        wordBreak: 'break-word',
        height: '70px',
        display: 'flex',
        alignItems: 'center'
      },
      configActionCell: {
        flex: '0 0 160px',
        height: '70px',
        display: 'flex',
        alignItems: 'center'
      },
      tableSubRows: {
        display: 'flex',
        width: '100%',
        background: 'rgb(239 239 239 / 50%)',
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
        borderTop: 0
      },
      subTable: {
        borderBottom: '3px solid rgba(224, 224, 224, 1)',
        '&:last-child': {
          border: 0
        }
      },
      configTableSubRows: {
        width: '100%',
        border: '0',
        display: 'flex',
        padding: '0px',
        alignItems: 'center',
        borderRadius: '8px',
        backgroundColor: '#fafafa',
        height: '70px'
      },
      configSubPropertyCell: {
        flex: '0 0 250px',
        paddingLeft: '32px',
        height: '70px',
        display: 'flex',
        alignItems: 'center'
      },
      configTableSubValueCell: {
        flex: '1',
        wordBreak: 'break-word',
        height: '70px',
        display: 'flex',
        alignItems: 'center'
      },
      configSubActionCell: {
        flex: '0 0 120px',
        height: '70px',
        display: 'flex',
        alignItems: 'center'
      },
      saveButtonBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '32px 0px',
        [theme.breakpoints.only('xs')]: {
          margin: '32px 0px'
        }
      },
      configContentBox: {
        flex: '1',
        background: 'transparent',
        padding: '32px 24px',
        '& > * > * > * > *': {
          [theme.breakpoints.down('xs')]: {
            whiteSpace: 'normal'
          }
        },
        [theme.breakpoints.only('xs')]: {
          padding: '8px'
        },
        [theme.breakpoints.up('md')]: {
          padding: '32px 56px'
        }
      },
      configTextBox: {
        textAlign: 'center',
        minWidth: '300px',
        '& > * > * textarea': {
          height: '100%'
        }
      },
      configProperty: {
        textAlign: 'center',
        fontSize: '24px',
        margin: '0px',
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 400,
        [theme.breakpoints.only('xs')]: {
          fontSize: '20px',
          whiteSpace: 'normal'
        }
      },
      saveButton: {
        width: '200px',
        [theme.breakpoints.only('xs')]: {
          width: '150px'
        }
      },
      configEditHeading: {
        fontSize: '32px',
        lineHeight: '1',
        fontFamily: 'Poppins, sans-serif',
        letterSpacing: 'normal',
        margin: '0px'
      },
      configEditOverlay: {
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column'
      },
      configOverlayHeaderBlock: {
        alignItems: 'center',
        justifyContent: 'space-between',
        display: 'flex',
        flexDirection: 'row',
        background: 'transparent',
        padding: '24px 24px 24px 24px',
        [theme.breakpoints.only('xs')]: {
          alignItems: 'flex-start',
          flexDirection: 'column-reverse',
          padding: '8px'
        }
      },
      configOverlayHeading: {
        display: 'flex',
        flexDirection: 'row',
        gap: '20px',
        background: 'transparent',
        [theme.breakpoints.only('xs')]: {
          paddingTop: '10px',
          paddingLeft: '20px'
        }
      },
      addConfigRow: {
        position: 'absolute',
        right: '-50px',
        top: '15px'
      },
      configOverlayCloseIcon: {
        display: 'flex',
        flexDirection: 'row',
        background: 'transparent',
        [theme.breakpoints.only('xs')]: {
          justifyContent: 'flex-end',
          width: '100%'
        },
        '& > * > *': {
          [theme.breakpoints.only('xs')]: {
            width: '30px'
          }
        }
      },
      configDeleteHeading: {
        flex: 'none',
        width: '600px',
        background: 'transparent',
        margin: '0px 0px 24px 0px',
        [theme.breakpoints.only('sm')]: {
          width: '490px',
          padding: '0px 20px 0px 0px'
        },
        [theme.breakpoints.only('xs')]: {
          width: '300px'
        }
      },
      configDeleteHeader: {
        textAlign: 'center',
        fontSize: '42px',
        margin: '0px',
        fontFamily: 'Poppins, sans-serif',
        [theme.breakpoints.only('sm')]: {
          fontSize: '35px'
        },
        [theme.breakpoints.only('xs')]: {
          fontSize: '25px'
        }
      },
      configDeleteDescription: {
        width: '600px',
        flex: 'none',
        background: 'transparent',
        [theme.breakpoints.only('sm')]: {
          width: '360px',
          padding: '0px 10px 0px 10px'
        },
        [theme.breakpoints.only('xs')]: {
          width: '300px',
          padding: '0px 10px 0px 10px'
        }
      },
      configDeleteDescriptionText: {
        textAlign: 'center',
        fontSize: '24px',
        margin: '0px',
        fontFamily: 'Poppins, sans-serif',
        [theme.breakpoints.only('xs')]: {
          fontSize: '20px',
          whiteSpace: 'normal'
        }
      },
      updateColumnBox: {
        background: 'transparent',
        margin: '0 0 24px'
      },
      updateConfigSaveButton: {
        [theme.breakpoints.down('xs')]: {
          height: '40px'
        }
      },
      configMappingTableOuterBox: {
        width: '95%',
        flex: 'none',
        background: 'transparent',
        padding: '0px 32px 0px 0px',
        [theme.breakpoints.down('sm')]: {
          padding: '5px 16px 16px'
        }
      },
      configMappingTableRows: {
        height: '70px'
      },
      configMappingHeadersProperty: {
        paddingLeft: '24px',
        lineHeight: '1.13',
        fontSize: '16px',
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 600,
        width: '30%'
      },
      configMappingTableValueCell: {
        wordBreak: 'break-word'
      },
      createNewClientContainer: {
        display: 'flex',
        flexDirection: 'column',
        margin: '0px auto',
        padding: '0px 20px',
        maxWidth: '1440px',
        height: '100%',
        [theme.breakpoints.only('xs')]: {
          padding: '0px 0px'
        }
      },
      createNewClientLogoBlock: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        background: 'transparent',
        padding: '32px 72px 32px 72px',
        margin: '0px 0px 24px 0px',
        [theme.breakpoints.only('xs')]: {
          padding: '32px 20px 0px 20px'
        }
      },
      createNewClientLogo: {
        '& > *': {
          [theme.breakpoints.only('xs')]: {
            height: '40px'
          }
        }
      },
      createNewClientCloseIcon: {
        '& > * > *': {
          [theme.breakpoints.only('xs')]: {
            width: '30px',
            height: '30px'
          }
        }
      },
      createClientInnerContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '524px',
        background: 'transparent',
        [theme.breakpoints.only('xs')]: {
          width: '100%',
          padding: '0px 20px 0px 20px'
        }
      },
      createNewClientHeading: {
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 600,
        fontSize: '48px',
        textAlign: 'center',
        margin: '0px',
        [theme.breakpoints.only('xs')]: {
          fontSize: '34px'
        }
      },
      createClientName: {
        background: 'transparent',
        height: '130px',
        minWidth: '100%',
        [theme.breakpoints.down('xs')]: {
          height: '110px'
        },
        '& > * > * > input': {
          [theme.breakpoints.down('xs')]: {
            height: '40px'
          }
        }
      },
      createTicketTemplate: {
        background: 'transparent',
        marginTop: '20px',
        minHeight: '300px',
        minWidth: '300px',
        '& > * > * textarea': {
          height: '100%'
        }
      },
      createClientErrorText: {
        fontSize: '16px',
        color: color.RED,
        fontFamily: 'Poppins, sans-serif',
        margin: '0px',
        [theme.breakpoints.down('xs')]: {
          paddingTop: '20px'
        }
      },
      createClientButtonBox: {
        background: 'transparent',
        margin: '32px 0px 0px 0px',
        [theme.breakpoints.down('xs')]: {
          margin: '22px 0px 0px 0px'
        }
      },
      createClientButton: {
        [theme.breakpoints.down('xs')]: {
          height: '40px',
          width: '100%'
        }
      },
      body: {
        overflow: props && props.showDrawer ? 'hidden' : 'auto'
      }
    })
  );

export const Tooltips = withStyles(() => ({
  tooltip: {
    fontSize: 14,
    fontFamily: 'Poppins, sans-serif',
    background: 'black',
    bottom: '-18px'
  },
  arrow: {
    '&:before': {
      border: '1px solid black'
    },
    color: 'black'
  }
}))(Tooltip);
